module.exports = __webpack_public_path__ + "static/LocomotionMC-MountainClimbers-3de9c2670596ca607f0febbf91efecf9.mp4";